/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationUserActionKind =
  (typeof GroupByConversationUserActionKind)[keyof typeof GroupByConversationUserActionKind];

export const GroupByConversationUserActionKind = {
  conversation_user_action: 'conversation_user_action',
} as const;
